import noAvatarImg from "../../../assets/noAvatar.png";

export const UserResultItem = ({ user, onAdd }) => {
    // const avatarSrc = user?.profilePic?.startsWith("http") 
    //     ? user.profilePic 
    //     : (user?.profilePic || "/public/noAvatar.png");

    const avatarSrc = user?.profilePic?.startsWith("http") 
        ? user.profilePic 
        : (user?.profilePic || noAvatarImg);

    return (
        <div className="userResult">
            <div className="detail">
                <img src={avatarSrc} alt={`${user.username}'s avatar`} />

                <span>
                    {user.username}
                </span>
            </div>

            <button onClick={() => onAdd(user)} className="addBtn">
                Start Chat
            </button>
        </div>
    );
};